module.exports = __webpack_public_path__ + "static/media/underline.8bdb6fb1.svg";